import { CommentModel } from "./comment";
import { FilmModel } from "app/models/film";
import { ContributorModel } from "app/models/contributor";
import { PersonModel } from "app/models/person";

export class ContentModel 
{
    contentID:number;
    publishDate:Date;
    ifApproved:boolean;
    ifDisplay:boolean;
    contentTitle:String;
    contentSubTitle:String;
    bannerImage:String;
    timesAccessed:number;
    ifFeatured:boolean;
    references:String[];
    contributors:ContributorModel[];
    filmsDiscussed:FilmModel[];
    filmmakersDiscussed:PersonModel[];
    images:Blob[];
//    List<CommentModel> comments;
    comments:CommentModel;
    contentData: string;
}


// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/models/content.ts